module.exports = __webpack_public_path__ + "static/media/groceryListIcon1.8f313b42.svg";